import React from "react";
import { useTranslation } from "react-i18next";
import VerifiedTwoToneIcon from "@mui/icons-material/VerifiedTwoTone";
import { ExpertVerificationStatus } from "../../../models/user";

interface ExpertVerifiedBadgeProps {
  status?: ExpertVerificationStatus | null;
  size?: "small" | "medium";
}

/**
 * Badge "Expert vérifié" réutilisable, affiché partout où un expert est présenté.
 * N'affiche rien tant que le statut n'est pas VERIFIED, afin que les experts
 * non vérifiés restent visibles mais sans badge.
 */
const ExpertVerifiedBadge: React.FC<ExpertVerifiedBadgeProps> = ({
  status,
  size = "small",
}) => {
  const { t } = useTranslation();

  if (status !== "VERIFIED") {
    return null;
  }

  const label = t("EXPERT_VERIFIED_BADGE");

  return (
    <VerifiedTwoToneIcon
      titleAccess={label}
      color="success"
      fontSize={size}
      sx={{ ml: 0.75, verticalAlign: "middle" }}
    />
  );
};

export default ExpertVerifiedBadge;
